module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-music-59f8be81ebcb243814b4659da62f2c76.jpg";